const WISHLIST_STORAGE_KEY = 'theme:wishlist';

function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]').map(Number).filter(Boolean);
  } catch {
    return [];
  }
}

function saveWishlist(ids) {
  const uniqueIds = [...new Set(ids.map(Number).filter(Boolean))];
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(uniqueIds));
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids: uniqueIds } }));
}

function isInWishlist(productId) {
  return getWishlist().includes(Number(productId));
}

function toggleWishlist(productId) {
  const id = Number(productId);
  const wishlist = getWishlist();

  if (wishlist.includes(id)) {
    saveWishlist(wishlist.filter((item) => item !== id));
    return false;
  }

  saveWishlist([id, ...wishlist]);
  return true;
}

function removeFromWishlist(productId) {
  const id = Number(productId);
  saveWishlist(getWishlist().filter((item) => item !== id));
}

function syncHeaderWishlist() {
  const hasItems = getWishlist().length > 0;

  document.querySelectorAll('[data-wishlist-header-link]').forEach((link) => {
    link.classList.toggle('is-active', hasItems);
  });
}

function syncWishlistButtons(root = document) {
  const wishlist = getWishlist();

  root.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const productId = Number(button.getAttribute('data-product-id'));
    const isActive = wishlist.includes(productId);

    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  syncHeaderWishlist();
}

function extractSectionId(element) {
  const section = element.closest('.shopify-section');
  return section?.id?.replace('shopify-section-', '') || '';
}

document.addEventListener('click', (event) => {
  const toggleButton = event.target.closest('[data-wishlist-toggle]');

  if (toggleButton) {
    event.preventDefault();
    toggleWishlist(toggleButton.getAttribute('data-product-id'));
    return;
  }

  const removeButton = event.target.closest('[data-wishlist-remove]');

  if (removeButton) {
    event.preventDefault();
    removeFromWishlist(removeButton.getAttribute('data-product-id'));
  }
});

document.addEventListener('wishlist:updated', () => {
  syncWishlistButtons();
});

class WishlistProducts extends HTMLElement {
  #isLoaded = false;

  connectedCallback() {
    this.loadProducts();
  }

  reload() {
    this.#isLoaded = false;
    this.loadProducts();
  }

  getSearchQuery() {
    return getWishlist()
      .map((id) => `id:${id}`)
      .join(' OR ');
  }

  async loadProducts() {
    if (this.#isLoaded) {
      return;
    }

    this.#isLoaded = true;

    const ids = getWishlist();

    if (ids.length === 0) {
      this.innerHTML = '';
      return;
    }

    const section = this.closest('.shopify-section');
    const sectionId = this.getAttribute('section-id') || extractSectionId(this);
    const url = `${Shopify.routes.root}search?type=product&q=${encodeURIComponent(this.getSearchQuery())}&section_id=${sectionId}`;

    try {
      const response = await fetch(url, { priority: 'low' });
      const html = await response.text();
      const tempDiv = new DOMParser().parseFromString(html, 'text/html');
      const wishlistElement = tempDiv.querySelector('wishlist-products');

      if (wishlistElement?.childElementCount > 0) {
        this.replaceChildren(...document.importNode(wishlistElement, true).childNodes);
        syncWishlistButtons(this);
      } else {
        this.innerHTML = '';
      }
    } catch {
      this.#isLoaded = false;
    }
  }
}

if (!window.customElements.get('wishlist-products')) {
  customElements.define('wishlist-products', WishlistProducts);
}

document.addEventListener('DOMContentLoaded', () => {
  syncWishlistButtons();
});

document.addEventListener('cart-drawer:refreshed', (event) => {
  syncWishlistButtons(event.target);
});

document.addEventListener('wishlist:updated', () => {
  document.querySelectorAll('wishlist-products').forEach((element) => {
    element.reload();
  });
});
